import React from "react";
import {
    IonButton,
    IonContent,
    IonHeader,
    IonIcon,
    IonInput,
    IonItem,
    IonList,
    IonPage,
    IonText,
    IonTitle,
    IonToolbar

} from "@ionic/react";
import { inject } from "mobx-react";
import { playOutline } from "ionicons/icons";

export interface ContadorProps {
}
export interface ContadorState {
    contador: string,
    timer: number,
    enableTimer : boolean,

}

@inject("store", "lang")
export default class Contador extends React.Component<ContadorProps, ContadorState> {

    state = {
        contador: "0",
        enableTimer : false,
        timer : 0,
    } as ContadorState;
    lastTimer?: Date;
    timerRef?: NodeJS.Timeout;
    componentDidMount(): void {
        this.timerRef = setInterval(() => {
            if (this.lastTimer && this.state.enableTimer) {
                let ms = (new Date().getTime()) - this.lastTimer.getTime();
                this.setState({ timer: this.state.timer + ms });

            }
            this.lastTimer = new Date();

        }, 100);


    }
    componentWillUnmount(): void {
        
    }

    getContador() {
        let n = this.state.contador;
        let i = parseFloat(n.replaceAll(",", "."));
        return i;
    }

    handleClickInc = (n: number) => (ev: any) => {
        let contador = this.getContador();
        contador += n;
        contador = Math.round(contador * 10000) / 10000;
        this.setState({ contador: contador.toString() });

    }

    handleStartTimer = (ev: any) => {
        this.setState({ enableTimer: true });
    }

    render(): React.ReactElement<any, string | React.JSXElementConstructor<any>> | string | number | {} | React.ReactNodeArray | React.ReactPortal | boolean | null | undefined {

        return <IonPage>
            <IonHeader>
                <IonToolbar color={"primary"}>
                    <IonTitle>Contador</IonTitle>
                </IonToolbar>
            </IonHeader>
            <IonContent>
                <IonList>
                    <IonItem>

                        <IonInput value={this.state.contador} onIonInput={(ev) => this.setState({ contador: ev.detail.value! })} labelPlacement="fixed" label="Total m3" />
                        <IonButton>Ok</IonButton>

                    </IonItem>
                    <IonItem>
                        <IonButton onClick={this.handleClickInc(1)}>+1</IonButton>
                        <IonButton onClick={this.handleClickInc(0.1)}>+0.1</IonButton>
                        <IonButton onClick={this.handleClickInc(0.01)}>+0.01</IonButton>
                        <IonButton onClick={this.handleClickInc(0.001)}>+0.001</IonButton>
                        <IonButton onClick={this.handleClickInc(0.0001)}>+0.0001</IonButton>
                    </IonItem>
                    <IonItem>
                        <IonButton onClick={this.handleStartTimer}><IonIcon icon={playOutline} /> </IonButton>
                        <IonText>{ this.state.timer ? (this.state.timer) : "00:00" }</IonText>
                    </IonItem>

                    <IonItem>
                        <IonButton>Reset</IonButton>
                    </IonItem>
                </IonList>
            </IonContent>

        </IonPage>
    }
}
